import { Auth } from "./Auth";

export class AuthBase implements Auth {
  private auth: { [key: string]: string } = { AppToken: "" };
  private expireIn = -1;

  public setAuth(token: string, expireIn?: number): void {
    this.auth.AppToken = this.auth.AppToken + token;

    if (expireIn) {
      this.expireIn = expireIn;
    }
  }

  public getAuth(): { [key: string]: string } {
    return this.auth;
  }

  public getAuthKey(): string {
    return "AppToken";
  }

  public doesTokenExpire(): boolean {
    const dateTime = Date.now();
    const timestamp = Math.floor(dateTime / 1000);

    return this.expireIn + 10 >= timestamp;
  }
}
